import { render, staticRenderFns } from "./EditorNewAssignmentModal.vue?vue&type=template&id=7bf2219a&scoped=true&"
import script from "./EditorNewAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./EditorNewAssignmentModal.vue?vue&type=script&lang=js&"
import style0 from "./EditorNewAssignmentModal.vue?vue&type=style&index=0&id=7bf2219a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf2219a",
  null
  
)

export default component.exports